import React from 'react'
import styled from '@emotion/styled'
import Banner2 from 'style/icons/pie.png'
import { colors } from 'style/theme'

const StyledEmptyList = styled.div({
	textAlign: 'center'
})
const EmptyListTitle = styled.h1({
	marginTop: 15,
	fontWeight: 400
})

const EmptyListSubtitle = styled.h2({
	color: colors.brandGray,
	margin: '15px 0',
	fontWeight: 400,
	fontSize: 16
})
const EmptyAccountsList = () => {
	return (
		<StyledEmptyList>
			<img src={Banner2} width={400} alt="banner"/>
			<EmptyListTitle>THERE ARE NO ACCOUNTS</EmptyListTitle>
			<EmptyListSubtitle>BE PATIENT ONE IS ON IT'S WAY</EmptyListSubtitle>
		</StyledEmptyList>
	)
}

export default EmptyAccountsList
